module.exports = __webpack_public_path__ + "static/media/carnivorous-plant.04471865.svg";